import { createListenerMiddleware } from '@reduxjs/toolkit';

export default createListenerMiddleware();
